import { ApiResource } from '@/core/models/api-resource.interface';
import { Company } from '@nxtpeople/nxt-vue-library';
import { LocationQuery } from 'vue-router';

export class CompanyService {
   async getCompanies(params?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Company>>>(`/companies`, { params });
      return response.data;
   }

   async getCompany() {
      throw Error('Method not implemented');
   }

   async postCompany() {
      throw Error('Method not implemented');
   }

   async putCompany(companyId: number, body: Partial<Company>) {
      return await http.put(`/companies/${companyId}`, body, {}).then((response) => response.data);
   }

   async deleteCompany() {
      throw Error('Method not implemented');
   }
}
